import { actionTypes } from './constants';
import * as Types from './types';

export const setIsWidgetsAuthenticated = (isWidgetsAuthenticated: boolean): Types.ISetIsWidgetsAuthenticatedAction => ({
    type: actionTypes.SET_IS_WIDGETS_AUTHENTICATED,
    payload: isWidgetsAuthenticated
});
